<template>
  <base-wrapper :loading="loading">
    <div class="space-y-8">
      <div class="grid grid-cols-1 grid-cols-5 gap-5">
        <base-widget
          label="Saldo Restok"
          :value="office.tempRestockBalance | toCurrency"
          clickable
          :active="tab === 'restock_balance'"
          @click="onChangeTab('restock_balance')"
        />
        <base-widget
          label="Saldo Deposit"
          :value="office.depositBalance | toCurrency"
          clickable
          :active="tab === 'deposit_balance'"
          @click="onChangeTab('deposit_balance')"
        />
        <base-widget
          label="Nilai Barang Dari Deposit"
          :value="office.multipliedDepositBalance | toCurrency"
          clickable
          :active="tab === 'multiplied_deposit_balance'"
          @click="onChangeTab('multiplied_deposit_balance')"
        />
        <base-widget
          label="Sisa Pembayaran"
          :value="office.overpaymentBalance | toCurrency"
          clickable
          :active="tab === 'overpayment_balance'"
          @click="onChangeTab('overpayment_balance')"
        />
        <base-widget
          label="Kurang Bayar"
          :value="office.debtBalance | toCurrency"
          clickable
          :active="tab === 'debt_balance'"
          @click="onChangeTab('debt_balance')"
        />
      </div>
      <div class="space-y-4">
        <h2
          class="mt-2 text-lg font-bold leading-7 text-gray-900 sm:truncate sm:text-2xl"
        >
          Riwayat Transaksi Saldo SC
        </h2>
        <balance-trx-table
          :office-id="me.office_id"
          :balance-type="tab"
          @update:loading="onUpdateLoadingOrderBalanceTrxes"
        />
      </div>
    </div>
  </base-wrapper>
</template>

<script>
import BaseWidget from '@/components/base/BaseWidget.vue';
import BalanceTrxTable from '@/components/balance-trx/balance-trx-table.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: {
    BaseWidget,
    BalanceTrxTable,
  },
  data() {
    return {
      loadingOffice: false,
      loadingOrderBalanceTrxes: false,
      office: {
        tempRestockBalance: 0,
        restockBalance: 0,
        depositBalance: 0,
        multipliedDepositBalance: 0,
        overpaymentBalance: 0,
        debtBalance: 0,
      },
      tab: 'restock_balance',
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    loading() {
      return this.loadingOffice || this.loadingOrderBalanceTrxes;
    },
  },
  methods: {
    async loadOffice() {
      this.loadingOffice = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.me.office_id}`,
        {
          params: {
            'fields[offices]':
              'temp_restock_balance,restock_balance,deposit_balance,multiplied_deposit_balance,overpayment_balance,debt_balance',
          },
        }
      );

      if (!err) {
        this.office.tempRestockBalance =
          res.data.attributes.temp_restock_balance;
        this.office.restockBalance = res.data.attributes.restock_balance;
        this.office.depositBalance = res.data.attributes.deposit_balance;
        this.office.multipliedDepositBalance =
          res.data.attributes.multiplied_deposit_balance;
        this.office.overpaymentBalance =
          res.data.attributes.overpayment_balance;
        this.office.debtBalance = res.data.attributes.debt_balance;
      }

      this.loadingOffice = false;
    },
    onChangeTab(tab) {
      this.tab = tab;
    },
    onUpdateLoadingOrderBalanceTrxes(value) {
      this.loadingOrderBalanceTrxes = value;
    },
  },
  created() {
    this.loadOffice();
  },
};
</script>
